import {useEffect, useState} from 'react';
import BreadCrumb from '../../components/breadCrumb';
import CustomFilterSelect from '../../shared/customFilterSelect';
import ModalContainer from '../../components/modalContainer';
import UserRolDescription from '../../components/userRolAdmin/userRolDescription';
import usersIcon from '../../assets/icons/userss.svg';
import './style.scss';
import ModalNewUser from '../../components/userRolAdmin/modalNewUser';
import {httpInterceptor} from "../../API/interceptor";
import {toast} from "react-toastify";

function UsersRolAdmin() {
    // STATES //
    const [modalNewUser, setModalNewUser] = useState(false);
    const [users, setUsers] = useState([]);

    const barrios = [
        {
            name: 'Castilla',
            code: 'CA',
            value: 1
        },
        {
            name: 'Aranjuez',
            code: 'AR',
            value: 1
        },
        {
            name: 'Campo valdez',
            code: 'CV',
            value: 1
        },
        {
            name: 'Manrique',
            code: 'MA',
            value: 1
        },
        {
            name: 'Zamora',
            code: 'ZA',
            value: 1
        }
    ];

    const itemsDescription = [
        {
            name: 'Rol',
            code: 'ROL',
            value: 2
        },
        {
            name: 'Documento',
            code: 'doc',
            value: 3
        },
        {
            name: 'Nombre',
            code: 'nom',
            value: 4
        },
        {
            name: 'Correo',
            code: 'cc',
            value: 5
        },
        {
            name: 'Estado',
            code: 'cont',
            value: 6
        },
        {
            name: 'Editar',
            code: 'edi',
            value: 7
        }
    ];

    function userCreated(isCreated) {
        if (isCreated) {
            getUsers()
        }
    }

    function getUsers() {
        httpInterceptor
            .get('users/list')
            .then(res => {
                // TODO interceptor does not work when refresh //
                let info = [];
                if (res?.status === 200) {
                    info = res.data.data
                } else if (res && res.success) {
                    info = res.data
                }
                if (info.length > 0) {
                    setUsers(info)
                }
            })
            .catch(() => {
                toast('Error obteniendo datos del servidor intente de nuevo', {
                    type: 'error'
                });
            });
    }

    useEffect(() => {
        getUsers();
    }, []);


    return (
        <>
            {modalNewUser && (
                <ModalContainer>
                    <ModalNewUser
                        typeModal={'create'}
                        setModalNewUser={setModalNewUser}
                        userCreated={userCreated}
                        item={{active:true, email:''}}
                    />
                </ModalContainer>
            )}

            <section className='usersRol-main-container'>
                <BreadCrumb/>
                <div className='filters-container'>
                    <div className='filters-top'>
                        <p className='title'>FILTROS DE BÚSQUEDA DE USUARIOS</p>
                        <button
                            onClick={() => setModalNewUser(true)}
                            className='add-schools-button'>
                            <div className='icon-container'>
                                <img src={usersIcon} alt=''/>
                            </div>
                            <p>AGREGAR USUARIO</p>
                        </button>
                    </div>
                    <div className='filters-content'>
                        <CustomFilterSelect optionsList={barrios} placeholder={'Nombre'}/>
                        <CustomFilterSelect
                            optionsList={barrios}
                            placeholder={'Apellido'}
                        />
                        <CustomFilterSelect
                            optionsList={barrios}
                            placeholder={'Documento'}
                        />
                        <CustomFilterSelect optionsList={barrios} placeholder={'Rol'}/>
                    </div>
                </div>
                <div className='schools-main-container'>
                    <div className='schools-top'>
                        <p className='title'>USUARIOS</p>
                        <p className='paginator-text'>
                            | Mostrando <span>{users.length}</span> de <span>{users.length}</span> resultados |
                        </p>
                    </div>
                    <div className='info-shools-content'>
                        <UserRolDescription
                            itemsDescription={itemsDescription}
                            itemUser={users}
                            userCreated={userCreated}
                        />
                    </div>
                </div>
            </section>
        </>
    );
}

export default UsersRolAdmin;
